import axios, {
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import { baseApiUrl } from 'env';

const DEFAULT_HEADERS: Record<string, string> = {
  'app-source': 'IntakeApp',
};

// NOTE: This client is intended for APIs that require a *different* auth token
// than the existing `services/httpClient.ts` client used by Orval today.
export const axiosM2MInstance = axios.create({
  baseURL: baseApiUrl,
  headers: DEFAULT_HEADERS,
});

const axiosAuth2ExternalInstance = axios.create({
  headers: DEFAULT_HEADERS,
});

const mockedUrls = new Set<string>([]);

export function hasM2MToken(): boolean {
  const auth = axiosM2MInstance.defaults.headers.common.Authorization;
  if (typeof auth !== 'string') return false;
  return auth.trim().length > 0;
}

export function clearM2MAuthorization() {
  delete axiosM2MInstance.defaults.headers.common.Authorization;
  delete axiosAuth2ExternalInstance.defaults.headers.common.Authorization;
}

export function markM2MUrlAsMocked(url: string) {
  mockedUrls.add(url.toLowerCase());
}

export function unmarkM2MUrlAsMocked(url: string) {
  mockedUrls.delete(url.toLowerCase());
}

export function sendM2MRequest<T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> {
  const httpClient = mockedUrls.has(config.url?.toLowerCase() ?? '')
    ? axiosAuth2ExternalInstance
    : axiosM2MInstance;

  const source = axios.CancelToken.source();
  const promise = httpClient({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }: AxiosResponse<T>) => data);

  // @ts-ignore - keep parity with existing `sendRequest`
  promise.cancel = () => {
    source.cancel('Query was cancelled.');
  };

  return promise;
}
